import React from "react";
import _get from "lodash/get";
import moment from "moment";
import queryString from "query-string";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import DailyStatusContainer from "./index";

const styles = (theme) => ({});

function DailyStatusCo(props) {
  return (
    <Grid container className={{}}>
      <Grid item xs={12} md={6} >
        <DailyStatusContainer
          viewType="TEAM"
          chartId={"dutyStatusLogChart"}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DailyStatusContainer
          viewType="TEAMDR"
          chartId={"dutyStatusCoLogChart"}
          {...props}
        />
      </Grid>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(DailyStatusCo)
);
